export default __webpack_public_path__ + "static/media/wSkirt_1_p3.9bce3663.jpeg";